"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeStatus = void 0;
var EmployeeStatus;
(function (EmployeeStatus) {
    EmployeeStatus["ACTIVE"] = "active";
    EmployeeStatus["TERMINATED"] = "terminated";
})(EmployeeStatus = exports.EmployeeStatus || (exports.EmployeeStatus = {}));
//# sourceMappingURL=employee-status.enum.js.map